<template>
  <modal wrapperClasses="agreement-modal">
    <h2 slot="header" class="title">
      <img :src="stashboardLogoImage" alt="stashboard-logo">

      <br/>Attention springbig fam! We have a lot of game-changing news to share with you about our recent platform update.</h2>

    <div slot="body" class="body">
      <h3>With this new expansion to the springbig platform, you get back the power to share whatever kind of content you want with your most loyal, highest-spending customers, while we secure your communications to provide additional protection for your exclusive content</h3>
      <ol>
        <li>  First, you’ll see the stashboard campaign creation page. Here you have the ability to write whatever engaging messages and upload exciting creative images to be displayed on what we call a stashboard, which is branded to your cannabis retail store.</li>
        <li>  Why is the deliverability score gone? Because with stashboards all of your campaigns are automatically 100% optimized!</li>
        <li>  Next, you can choose from our library of pre-optimized text messages that will be sent to notify your customer of your new content. </li>
        <li>  You will still have access to the other awesome autoconnects and dynamic filtering options you love, allowing you to target your audience and personalize the experience.</li>
        <li>  Don’t forget you can add links for track offers, the target wallet, or any links to your website, e-commerce, etc. onto your stashboard!</li>
        <li>  When your customer receives the pre-optimized text, they will be directed to your stashboard through the secure link, keeping your communications exclusive to your members.</li>
      </ol>
      <p>To make this easier, we went ahead and created some educational content for you and your team. Please take advantage of the link below to learn more about stashboards!</p>
      <a href="https://springbig.zendesk.com/hc/en-us/articles/1500010744021-Webinar-The-Next-Level-of-Texting-with-stashboards" target="_blank" rel="noopener noreferrer"><u>click here for more information</u></a>
      <p>We want to hear from you! If you have any questions, please contact your clients success manager today</p>
    </div>

    <div slot="action"
         class="button modal-click-action justify-center" data-cy='agreement-modal-button'
         @click="$emit('rejectAgreementModal', agreementCheck)">
      get started
    </div>

    <div slot="footer" class="modal-footer">
      <label>
        <input type="checkbox" v-model="agreementCheck">
        do not show this message again
      </label>
    </div>
  </modal>
</template>

<script>
import Modal from "../shared/Modal.vue";
import stashboardLogoImage from "campaigns/stashboards_logo_color.png";

export default {
  name: "AgreementModal",

  components: { Modal },

  data() {
    return {
      agreementCheck: false,
      stashboardLogoImage
    }
  }
}
</script>